import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { DateTimeHelperService } from '../date-time-helper/date-time-helper.service';

/*
 * Formats a utc datetime string as a local date string.
 * Assumes the given datetime string value is UTC.
 * Usage:
 *   value | dateTimeFormatter:outputFormat
 * Example:
 *   {'2017-10-13 00:00:00.0000000' | dateTimeFormatter}
 *   formats to: '13 10 2017'
 */
@Pipe({ name: 'dateTimeFormatter' })
export class DateTimeFormatterPipe implements PipeTransform {
  constructor(
    private dateTimeHelper: DateTimeHelperService,
  ) {
  }

  public transform(value: string | Date, format: string = this.dateTimeHelper.dateFormat, inputDateFormat: string = this.dateTimeHelper.defaultDateFormat): string {
    if (!value) {
      return;
    }

    if(value instanceof Date){
      value = value.toISOString();
    }

    if (!this.dateTimeHelper.isValidDateString(value)) {
      return;
    }
    // Update moment with current locale
    moment.locale(window.navigator.language);


    return moment(value, inputDateFormat).format(format);
  }
}
